module.exports = __webpack_public_path__ + "img/可怜.33dc6155.png";